import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Forgotpassword from '../components/Forgotpassword';

const Forgoten = () => {
    return (
        <div>
            <Header />
            <Forgotpassword />
            <Footer />
        </div>
    );
};

export default Forgoten;
